export default "__VITE_ASSET__C$DkCMZa__"